import {get} from "lodash"
import BaseService from "./Base"
import {
    PaymentsReconciliationListRequest,
    PaymentsReconciliationListResponse,
    ReprocessPaymentsReconciliationRowsRequest,
    ReprocessPaymentsReconciliationRowsResponse,
    RetryPaymentsReconciliationRowRequest,
    RetryPaymentsReconciliationRowResponse
} from "types/integrations/paymentsReconciliation"

class PaymentsReconciliationService extends BaseService {
    async listRows(params: PaymentsReconciliationListRequest): Promise<PaymentsReconciliationListResponse> {
        const response = await this.post("/v1/student-account/payments-reconciliation/list", params)
        return get(response, "data", {success: false, total: 0, data: []})
    }

    async reprocessRows(
        params: ReprocessPaymentsReconciliationRowsRequest
    ): Promise<ReprocessPaymentsReconciliationRowsResponse> {
        const response = await this.post("/v1/student-account/payments-reconciliation/reprocess", params)
        return get(response, "data", {
            success: false,
            data: {
                processedRows: 0,
                skippedRows: 0,
                failedRows: 0
            }
        })
    }

    async retryPayment(params: RetryPaymentsReconciliationRowRequest): Promise<RetryPaymentsReconciliationRowResponse> {
        const response = await this.post("/v1/student-account/payments-reconciliation/retry-payment", params)
        return get(response, "data", {success: false, data: {message: ""}})
    }
}

export default PaymentsReconciliationService
